<template>
	<div>
		<!-- 顶部栏 -->
		<div class="topbar">
			<div>
				<el-input v-model="searchValue" size="small" placeholder="" prefix-icon="el-icon-search"
					class="search-input" @keypress.enter.native="search()" />
				<el-button type="primary" icon="el-icon-search" size="small" :disabled="!searchValue"
					@click.stop="search()">
					搜索
				</el-button>
			</div>
			<el-button type="primary" icon="el-icon-plus" size="small" @click.stop="openAddReviewTabDialog()">
				新增标签
			</el-button>
		</div>
		<!-- 内容 -->
		<el-table v-loading="loading" :data="reviewTabList" :header-cell-style="{ background: '#F5F7FA' }"
			style="width: 100%; margin-bottom: 20px">
			<el-table-column prop="liveVideoTabId" label="#" align="center" width="100" />
			<el-table-column label="创建时间" align="center" width="200">
				<template slot-scope="scope">
					{{ scope.row.createTime | formatDateTime }}
				</template>
			</el-table-column>
			<el-table-column prop="liveVideoTabTitle" label="标题" align="center" />
			<el-table-column prop="liveVideoTabTitleRussian" label="俄语标题" align="center" />
			<el-table-column label="操作" align="center" width="350">
				<template slot-scope="scope">
					<el-button size="small" :type="scope.row.isDefault ? 'warning' : 'success'"
						@click.stop="setReviewTabDefault(scope.row)">
						{{ scope.row.isDefault ? "取消默认" : "设为默认" }}
					</el-button>
					<el-button size="small" type="primary" @click.stop="openEditReviewTabDialog(scope.row)">
						编辑
					</el-button>
					<el-button size="small" :type="scope.row.isDeleted ? 'warning' : 'danger'"
						@click.stop="deleteReviewTab(scope.row)">
						{{ scope.row.isDeleted ? "恢复" : "删除" }}
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页 -->
		<el-pagination v-show="totalCount > pageSize" background layout="prev, pager, next" :total="totalCount"
			:page-size="pageSize" :current-page="currentPage" @current-change="currentChange" />

		<!-- addReviewTagsDialog -->
		<el-dialog title="新增视频标签" :visible.sync="addReviewTagsDialog" width="60%">
			<el-form ref="reviewTabFormRef" :model="addReviewTagsForm" status-icon :rules="reviewTabFormRules">
				<el-form-item label="标题" label-width="80px" prop="liveVideoTabTitle">
					<el-input v-model="addReviewTagsForm.liveVideoTabTitle" autocomplete="off" style="width: 40%" />
				</el-form-item>
				<el-form-item label="俄语标题" label-width="80px" prop="liveVideoTabTitleRussian">
					<el-input v-model="addReviewTagsForm.liveVideoTabTitleRussian" autocomplete="off"
						style="width: 40%" />
				</el-form-item>
				<el-form-item label="是否默认" label-width="80px" prop="default">
					<el-radio-group v-model="addReviewTagsForm.isDefault">
						<el-radio :label="1">是</el-radio>
						<el-radio :label="0">否</el-radio>
					</el-radio-group>

				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="addReviewTagsDialog = false">
					取 消
				</el-button>
				<el-button type="primary" size="small" @click="addReviewTab()">
					确 定
				</el-button>
			</div>
		</el-dialog>

		<!-- editReviewTagsDialog -->
		<el-dialog title="编辑视频标签" :visible.sync="editReviewTagsDialog" width="60%">
			<el-form ref="editReviewTabFormRef" :model="editReviewTagsForm" :rules="reviewTabFormRules">
				<el-form-item label="标题" label-width="80px" prop="liveVideoTabTitle">
					<el-input v-model="editReviewTagsForm.liveVideoTabTitle" autocomplete="off" style="width: 40%" />
				</el-form-item>
				<el-form-item label="俄语标题" label-width="80px">
					<el-input v-model="editReviewTagsForm.liveVideoTabTitleRussian" autocomplete="off"
						style="width: 40%" />
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="editReviewTagsDialog = false">
					取 消
				</el-button>
				<el-button type="primary" size="small" @click="editReviewTab()">
					确 定
				</el-button>
			</div>
		</el-dialog>


	</div>


</template>

<script>
	import {
		addTag,
		deleteTag,
		updateTag,
		getTagList
	} from "@/api/mai/liveReviews/liveReviews";
	import {
		deepClone
	} from "@/utils/index"
	import {
		isVaild
	} from "@/utils/validate"
	export default {

		data() {

			const validateLiveVideoTitle = (rule, value, callback) => {
				if (!isVaild(value)) {
					callback(new Error("标题不能为空"))
				} else {
					callback()
				}
			}

			return {
				loading: false, // 加载开关

				searchValue: "", // 搜索内容
				totalCount: 0, // 列表总数
				pageSize: 10, // 单页条数
				currentPage: 1, // 当前页码
				reviewTabList: [], // 所有视频标签列表
				addReviewTagsDialog: false, // 添加视频标签对话框
				addReviewTagsForm: {}, // 添加视频标签表单
				editReviewTagsDialog: false, // 编辑视频标签对话框
				editReviewTagsForm: {}, // 编辑视频标签表单
				// 新增视频标签规则
				reviewTabFormRules: {
					liveVideoTabTitle: [{
						validator: validateLiveVideoTitle,
						trigger: "blur"
					}],
					// default: [{
					// 	required: true,
					// 	message: "必填项",
					// 	trigger: "blur"
					// }],
				},

			}
		},
		async created() {
			this.getReviewTabList()
		},
		methods: {
			setReviewTabDefault(row) {
				const data = deepClone(row)
				data.isDefault = !data.isDefault
				updateTag(data).then((res) => {
					if (res.code === 200) {
						this.$message.success("设置成功")
					}
					this.getReviewTabList()
				})
			},
			/**
			 * 搜索
			 */
			search() {
				this.currentPage = 1;
				this.getReviewTabList();
			},
			/**
			 * 翻页
			 *
			 * @param {number} currentPage 当前页码
			 */
			currentChange(currentPage) {
				this.currentPage = currentPage;

				this.getReviewTabList();
			},


			/**
			 * 打开添加视频标签对话框
			 */
			openAddReviewTabDialog() {
				this.addReviewTagsDialog = true;
				this.addReviewTagsForm = {
					isDefault: 0
				}
				this.$nextTick(() => {
					this.$refs["reviewTabFormRef"].clearValidate();
				});
			},
			/**
			 * 添加视频标签
			 */
			addReviewTab() {
				this.$refs["reviewTabFormRef"].validate((valid) => {
					if (valid) {
						this.addReviewTagsDialog = false;
						const data = {
							liveVideoTabTitleRussian: this.addReviewTagsForm.liveVideoTabTitleRussian,
							liveVideoTabTitle: this.addReviewTagsForm.liveVideoTabTitle,
						};
						addTag(data).then((res) => {
							if (res.code === 200) {


								if (this.addReviewTagsForm.isDefault) {
									updateTag({
										liveVideoTabId: res.data,
										liveVideoTabTitleRussian: this.addReviewTagsForm
											.liveVideoTabTitleRussian,
										liveVideoTabTitle: this.addReviewTagsForm
											.liveVideoTabTitle,
										isDefault: true
									}).then((res) => {
										if (res.code === 200) {
											this.$message({
												message: "添加成功!",
												type: "success",
											});
											this.getReviewTabList();
										} else {
											console.log('set default failed')
										}
									})
								} else {

									this.$message({
										message: "添加成功!",
										type: "success",
									});
									this.getReviewTabList();

								}
							} else {
								this.$message({
									message: res.message,
									type: "warning",
								})
							}
						});
					}
				});
			},
			/**
			 * 打开编辑视频标签对话框
			 *
			 * @param {object} row 所选对象信息
			 */
			openEditReviewTabDialog(row) {
				this.$set(this.editReviewTagsForm, "liveVideoTabId", row.liveVideoTabId);
				this.$set(this.editReviewTagsForm, "liveVideoTabTitle", row.liveVideoTabTitle);
				this.$set(this.editReviewTagsForm, "liveVideoTabTitleRussian", row.liveVideoTabTitleRussian);
				this.$set(this.editReviewTagsForm, "isDefault", row.isDefault);
				this.editReviewTagsDialog = true;
				this.$nextTick(() => {
					this.$refs.editReviewTabFormRef.clearValidate();
				});
			},
			/**
			 * 编辑视频标签
			 */
			editReviewTab() {
				this.$refs.editReviewTabFormRef.validate((res) => {
					if (res) {
						this.editReviewTagsDialog = false;
						const data = deepClone(this.editReviewTagsForm);
						updateTag(data).then((res) => {
							if (res.code === 200) {
								this.$message({
									message: "修改成功!",
									type: "success",
								});
								this.getReviewTabList();
							} else {
								this.$message({
									message: res.message,
									type: "warning",
								});
							}
						});
					}
				})

			},
			/**
			 * 删除视频标签
			 *
			 * @param {object} row 所选对象信息
			 */
			deleteReviewTab(row) {
				const params = {
					liveVideoTabId: row.liveVideoTabId,
				};
				this.$confirm("是否删除该视频标签", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
					})
					.then(() => {
						deleteTag(params).then((res) => {
							if (res.code === 200) {
								this.$message({
									type: "success",
									message: "删除成功",
								});
								this.getReviewTabList();
							} else {
								this.$message({
									type: "warning",
									message: res.message,
								});
							}
						});
					})
			},

			/**
			 * 分页获取视频标签列表
			 */
			getReviewTabList() {
				this.loading = true;
				const params = {
					// sortName: "",
					// sortOrder: "",
					pageNumber: this.currentPage || 1,
					pageSize: this.pageSize || 10,
					keyWord: this.searchValue || "",
					where: "",
				};
				getTagList(params).then((res) => {
					this.reviewTabList = res.data.rows;
					this.totalCount = res.data.total;
					this.loading = false;
				});
			},

		},
	}
</script>

<style>
</style>
